import { useState } from 'react'
import { Box } from '@mui/material'
import { useAppData } from '../contexts/AppDataContext'
import { resolveAssetUrl } from '../services/assetUrl'
import Logo from './Logo'

/**
 * Shows the current event's logo when set (and it loads), otherwise falls back
 * to the default Vericast logo.
 */
export default function EventLogo({ height = 32 }: { height?: number }) {
  const { event } = useAppData()
  const [broken, setBroken] = useState(false)

  if (event?.logoUrl && !broken) {
    return (
      <Box
        component="img"
        src={resolveAssetUrl(event.logoUrl)}
        alt={event.name}
        onError={() => setBroken(true)}
        sx={{ height, width: 'auto', maxWidth: 200, display: 'block' }}
      />
    )
  }
  return <Logo />
}
